import './FoodImage.css';

import { useState } from 'react';
import { captureProductEvent } from '../utils/productAnalytics';

const FoodImage = ({ imageUrls, altText }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageError, setImageError] = useState(false);
  const [isLoadingNextImage, setIsLoadingNextImage] = useState(false);

  const handleImageError = () => {
    setIsLoadingNextImage(false);
    if (currentImageIndex < imageUrls.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
      setImageError(false);
    } else {
      setImageError(true);
    }
  };

  const handleImageLoad = () => {
    setIsLoadingNextImage(false);
  };

  const goToPrevious = e => {
    e.stopPropagation();
    captureProductEvent('menu-item-image-viewed', { direction: 'previous', imageCount: imageUrls.length });
    setImageError(false);
    setIsLoadingNextImage(true);
    setCurrentImageIndex(prev => (prev === 0 ? imageUrls.length - 1 : prev - 1));
  };

  const goToNext = e => {
    e.stopPropagation();
    captureProductEvent('menu-item-image-viewed', { direction: 'next', imageCount: imageUrls.length });
    setImageError(false);
    setIsLoadingNextImage(true);
    setCurrentImageIndex(prev => (prev === imageUrls.length - 1 ? 0 : prev + 1));
  };

  if (imageError || !imageUrls || imageUrls.length === 0) {
    return (
      <div className="food-image-placeholder">
        <span className="placeholder-icon">🍽️</span>
        <small>Image failed to load</small>
      </div>
    );
  }

  const hasMultipleImages = imageUrls.length > 1;

  return (
    <div className="food-image-container">
      {hasMultipleImages && (
        <button className="image-nav-arrow image-nav-left" onClick={goToPrevious} aria-label="Previous image">
          ←
        </button>
      )}

      <div className="image-wrapper">
        <img
          src={imageUrls[currentImageIndex]}
          alt={altText}
          className="food-image"
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={handleImageError}
          onLoad={handleImageLoad}
        />

        {isLoadingNextImage && (
          <div className="image-loading-overlay">
            <div className="image-loading-spinner"></div>
            <span className="image-loading-text">Loading image...</span>
          </div>
        )}
      </div>

      {hasMultipleImages && (
        <button className="image-nav-arrow image-nav-right" onClick={goToNext} aria-label="Next image">
          →
        </button>
      )}

      {hasMultipleImages && (
        <div className="image-counter">
          {currentImageIndex + 1} / {imageUrls.length}
        </div>
      )}
    </div>
  );
};

export default FoodImage;
